import React, { useRef } from 'react'
import { useDrag, useDrop } from 'react-dnd'

function DragAndDrop({ id, itemType, index, onMove, onDrop, children, className }) {
  const ref = useRef(null)
  const [{ handlerId }, drop] = useDrop({
    accept: itemType,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId()
      }
    },
    hover(item, monitor) {
      if (!ref.current) return
      const dragIndex = item.index
      const hoverIndex = index
      if (dragIndex === hoverIndex) return
      const hoverBoundingRect = ref.current.getBoundingClientRect()
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      const clientOffset = monitor.getClientOffset()
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return
      onMove(dragIndex, hoverIndex)
      item.index = hoverIndex
    },
    drop() {
      if (onDrop) onDrop()
    }
  })

  const [{ isDragging }, drag] = useDrag({
    type: itemType,
    item: () => ({ id, index }),
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  })

  drag(drop(ref))

  return (
    <div
      ref={ref}
      style={{ opacity: isDragging ? 0.5 : 1 }}
      data-handler-id={handlerId}
      className={className}
    >
      {children}
    </div>
  )
}

export default DragAndDrop
